import type { ReactNode } from "react";

import { INTERACTIVE } from "@/lib/interaction";

type ActionTileProps = {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
};

/** 프로필 모달 위쪽의 정사각 아이콘 + 라벨 버튼 (시안 02-1) */
export function ActionTile({ icon, label, onClick, disabled }: ActionTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`group flex flex-1 flex-col items-center gap-1.75 rounded-xl disabled:opacity-40 ${INTERACTIVE}`}
    >
      <span className="bg-paper text-body group-hover:bg-chip group-active:bg-line flex size-11 items-center justify-center rounded-[15px] transition-colors [&_svg]:size-4.5">
        {icon}
      </span>
      <span className="text-body text-xs">{label}</span>
    </button>
  );
}
